/* eslint-disable no-unused-vars */
export const tableConfig = {
  border: 'none',
  stripe: true,
  size: 'small',
  'header-row-class-name': 'ake_table_header',
  'cell-class-name': ({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) => {
    const reg = /Time$/
    if (column.property && reg.test(column.property)) {
      return 'time_cell'
    }
    return ''
  },
  'show-overflow': true,
  'show-header-overflow': true,
  // 'custom-config': { storage: true },
  'column-config': { resizable: true, minWidth: 80 },
  'auto-resize': true,
  // 'max-height': 200,
}
